/**
 * @generated SignedSource<<1fddfb4674d5361bab51ed5a1301bdc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatReportProductReceivedPost$data = {
  readonly id: string;
  readonly " $fragmentType": "ChatReportProductReceivedPost";
};
export type ChatReportProductReceivedPost$key = {
  readonly " $data"?: ChatReportProductReceivedPost$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatReportProductReceivedPost">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatReportProductReceivedPost",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};

(node as any).hash = "20a82481c16f2313777803b5b902e708";

export default node;
